export default __webpack_public_path__ + "static/media/Sintony.731adbd8.eot";